  import { Component, inject, OnInit, OnDestroy } from '@angular/core';
  import { RouterOutlet } from '@angular/router';
  import { Api } from './services/api';
  import { Navbar } from './components/navbar/navbar';
  import { PermissionService } from './services/permission.service';
  import { NotificationsService } from './services/notifications.service';
  import { SessionService } from './services/session.service';
  import { jwtDecode } from 'jwt-decode';
  import { ChangeDetectorRef } from '@angular/core';

  @Component({
    selector: 'app-root',
    imports: [RouterOutlet, Navbar],
    templateUrl: './app.html',
    styleUrl: './app.css'
  })
  export class App implements OnInit, OnDestroy {
    protected title = 'crm-front';
    public api = inject(Api);
    public showLoading: boolean = false;

    constructor(
      private permissionService: PermissionService, 
      private cdr: ChangeDetectorRef,
      private notificationsService: NotificationsService,
      private sessionService: SessionService
    ){
      this.api.fireLoading.subscribe((action:boolean) =>{
        this.showLoading = action;
      })
    }


  ngOnInit() {
    const token = localStorage.getItem('crmtoken');
    if (token) {
      try {
        const decoded: any = jwtDecode(token);

        // Validar que el token no esté expirado
        const currentTime = Date.now() / 1000;
        if (decoded.exp && decoded.exp < currentTime) {
          console.warn('Token expirado, limpiando sesión...');
          this.sessionService.clearUserData();
          return;
        }

        if (decoded.permisos) {
          this.permissionService.setPermissions(decoded.permisos);
        }

        if (decoded.userId) {
          this.permissionService.loadPermissions(decoded.userId).subscribe(() => {
            this.cdr.detectChanges(); 
          });
        }

        // Solo iniciar notificaciones si el usuario está autenticado y tiene userId
        if (decoded.userId && this.isUserLoggedIn()) {
          console.log('✅ Usuario autenticado, iniciando polling de notificaciones...');
          this.notificationsService.startPolling();
        } else {
          console.log('❌ Usuario no autenticado completamente, no se inician notificaciones');
        }
      } catch (error) {
        console.error('Error al decodificar token:', error);
        this.sessionService.clearUserData();
      }
    } else {
      console.log('❌ No hay token, usuario no logueado');
    }
  }

  /**
   * Verifica si el usuario está completamente logueado
   */
  private isUserLoggedIn(): boolean {
    const token = this.sessionService.getToken();
    const userData = this.sessionService.getUserData();
    
    // Verificar que existe token
    if (!token) {
      return false;
    }

    // Verificar que el token no esté expirado
    try {
      const decoded = this.sessionService.decodeToken();
      if (!decoded || !decoded.userId) {
        return false;
      }

      const currentTime = Date.now() / 1000;
      if (decoded.exp && decoded.exp < currentTime) {
        return false;
      }
    } catch (error) {
      return false;
    }

    // Opcionalmente verificar que existan datos de usuario básicos
    return userData ? true : true; // Cambia a `userData ? true : false` si quieres ser más estricto
  }

  ngOnDestroy() {
    // Detener el polling cuando se destruya el componente
    this.notificationsService.stopPolling();
  }
}